/**
 * GSAP animations for hhm-text-image block: scroll-triggered staggered reveal,
 * image scale-in, text content fade-up, badge stagger, CTA hover.
 */
(function () {
	'use strict';

	function init() {
		if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
			return;
		}
		gsap.registerPlugin(ScrollTrigger);

		const sections = document.querySelectorAll('.hhm-text-image-section');
		if (!sections.length) return;

		const easeSnappy = 'power2.out';
		const easeBack = 'back.out(1.1)';

		sections.forEach(function (section) {
			const figure = section.querySelector('.hhm-text-image__figure');
			const img = section.querySelector('.hhm-text-image__img');
			const caption = section.querySelector('.hhm-text-image__caption');
			const heading = section.querySelector('.hhm-text-image__heading');
			const desc = section.querySelector('.hhm-text-image__desc');
			const badgesList = section.querySelector('.hhm-text-image__badges');
			const badges = section.querySelectorAll('.hhm-text-image__badge');
			const cta = section.querySelector('.hhm-text-image__cta');

			// ----- 1. Image: scale up + fade in (slight overshoot) -----
			if (figure) {
				if (img) {
					gsap.set(img, { opacity: 0, scale: 0.92 });
					gsap.to(img, {
						opacity: 1,
						scale: 1,
						duration: 0.85,
						ease: easeBack,
						scrollTrigger: {
							trigger: figure,
							start: 'top 88%',
							toggleActions: 'play none none none',
						},
					});
				}
				if (caption) {
					gsap.set(caption, { opacity: 0, y: 16 });
					gsap.to(caption, {
						opacity: 1,
						y: 0,
						duration: 0.5,
						delay: 0.25,
						ease: easeSnappy,
						scrollTrigger: {
							trigger: figure,
							start: 'top 88%',
							toggleActions: 'play none none none',
						},
					});
				}
			}

			// ----- 2. Text content: heading, description, badges, CTA — staggered -----
			const contentEls = [heading, desc].filter(Boolean);
			if (contentEls.length) {
				gsap.set(contentEls, { opacity: 0, y: 28 });
				gsap.to(contentEls, {
					opacity: 1,
					y: 0,
					duration: 0.6,
					stagger: 0.1,
					ease: easeSnappy,
					scrollTrigger: {
						trigger: section.querySelector('.hhm-text-image__content') || section,
						start: 'top 85%',
						toggleActions: 'play none none none',
					},
				});
			}

			if (badges.length) {
				gsap.set(badges, { opacity: 0, y: 20 });
				gsap.to(badges, {
					opacity: 1,
					y: 0,
					duration: 0.5,
					stagger: 0.08,
					delay: 0.12,
					ease: easeSnappy,
					scrollTrigger: {
						trigger: badgesList || section,
						start: 'top 85%',
						toggleActions: 'play none none none',
					},
				});
			}

			if (cta) {
				gsap.set(cta, { opacity: 0, y: 20 });
				gsap.to(cta, {
					opacity: 1,
					y: 0,
					duration: 0.5,
					delay: 0.15,
					ease: easeSnappy,
					scrollTrigger: {
						trigger: section.querySelector('.hhm-text-image__content') || section,
						start: 'top 85%',
						toggleActions: 'play none none none',
					},
				});

				// ----- 3. CTA hover: subtle scale -----
				cta.addEventListener('mouseenter', function () {
					gsap.to(cta, {
						scale: 1.04,
						duration: 0.3,
						ease: easeSnappy,
					});
				});
				cta.addEventListener('mouseleave', function () {
					gsap.to(cta, {
						scale: 1,
						duration: 0.35,
						ease: easeSnappy,
					});
				});
			}
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
